// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"be025b67","239":"ea6fc2b1","667":"beb9ee26"}[chunkId] + ".chunk.js";
};